
import React, {FC} from 'react';
import Button from 'components/Button';
import {useContextRemaining} from 'components/useHolder/remaining';
import {observer} from 'mobx-react-lite';

import * as styles from './styles.module.scss';

type CheckExitProps = {
	onExit: () => void
	onCancel: () => void
}

const CheckExit: FC<CheckExitProps> = observer(({onExit, onCancel}) => {
	const remaining = useContextRemaining();
	return (
		<div className={styles.exit}>
			<p>
				You have <em>{remaining} remaining</em> to
				complete your reservation.
			</p>
			<p>
				Are you sure you want to pick a different time? This
				slot will be released and made available to others.
			</p>
			<div className={styles.buttons}>
				<Button variant='primary' onClick={onCancel}>
					Keep current
				</Button>
				<Button variant='light' onClick={onExit}>
					Release slot
				</Button>
			</div>
		</div>
	);
});

export default CheckExit;
